/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import { useMemo, useState } from 'react';
import ThemeEnum from '../enums/theme.enum';
import { darkTheme, lightTheme } from '../index';
import { AuthStorage } from '../../../services/storage/auth.storage';

const useColorMode = () => {
  const [mode, setMode] = useState(AuthStorage.getThemeMode() || ThemeEnum.LIGHT_MODE);

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => {
          const newMode = prevMode === ThemeEnum.LIGHT_MODE ? ThemeEnum.DARK_MODE : ThemeEnum.LIGHT_MODE;
          AuthStorage.changeThemeMode(newMode);
          return newMode;
        });
      },
    }),
    [],
  );

  const currentTheme = useMemo(() => (mode === ThemeEnum.LIGHT_MODE ? lightTheme : darkTheme), [mode]);

  return {
    colorMode,
    currentTheme,
  };
};

export default useColorMode;
